// Self-hosted on the marketing-site static storage + CDN: the PDFs live at
// `src/apps/site/public/legal/` and are served at `worldofwow.com/legal/...`
// via Azure `$web` + Front Door. Replaces the prior `/terms-conditions`
// anchors, which 404'd (the static site has no such page). These go live once
// the marketing site is deployed.
export const TERMS_OF_USE_URL = "https://worldofwow.com/legal/terms-of-service.pdf";
export const PRIVACY_POLICY_URL = "https://worldofwow.com/legal/privacy-policy.pdf";
